<div class="carousel-wrapper">
  <div #carouselContainer class="carousel-container">
    <div #carouselTrack class="carousel-track">
      <ng-content></ng-content>
    </div>
  </div>
</div>

